import React, { useMemo, useState } from 'react';
import { Text, Heading } from '@opendoor/bricks/core';

import { ClosingTasks } from 'sellDirect/helpers/closingTasks';
import { UnderContractOffer } from 'sellDirect/OfferContext';
import { StepInfo, Wizard } from 'shared/components/Wizard';
import { ClosingTaskWizardLayout } from 'sellDirect/components/closingDash/ClosingTaskWizardLayout';
import { DisclosuresForm } from 'sellDirect/components/closingDash/disclosures/DisclosuresForm';
import { getHubSellingRoute } from 'shared/helpers/routes';
import {
  ClosingFAQs,
  getDisclosuresFaqs,
  getDisclosuresAgentFaqs,
} from 'sellDirect/components/closingDash/ClosingFAQs';
import { useHistory } from 'platform/HistoryProvider';
import { useQualificationContext } from 'shared/helpers/QualificationContext';
export interface StaticDisclosuresWizardProps {
  offer: UnderContractOffer;
  closingTasks: ClosingTasks;
}

/**
 * Wizard to collect additional home disclosures
 *
 * TODO (Alex): Add component test
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const StaticDisclosuresWizard: React.FC<StaticDisclosuresWizardProps> = ({
  offer,
  closingTasks,
}) => {
  const { addressUUID } = useQualificationContext();
  const { history, goBack } = useHistory();
  const initialLocation = useMemo(() => history.location, [history]);
  const [inEditMode, setInEditMode] = useState(false);
  const faqs = offer.shouldSeeAgentExperience ? getDisclosuresAgentFaqs() : getDisclosuresFaqs();
  const DisclosuresSteps: StepInfo[] = [
    {
      title: 'Disclosures',
      // eslint-disable-next-line react/display-name
      content: () => (
        <ClosingTaskWizardLayout
          rightComponent={
            <ClosingFAQs faqs={faqs} hideTitle data-testid="disclosures-closing-faqs" />
          }
        >
          <Text my={9} color="neutrals90">
            Answer a few questions about the property that we’ll pass along to the future owner.
          </Text>
          <>
            <Heading as="h2" fontSize="s3" fontWeight="bold" my={8}>
              Plumbing and other home information
            </Heading>
            <DisclosuresForm
              offer={offer}
              closingTasks={closingTasks}
              setInEditMode={setInEditMode}
            />
          </>
        </ClosingTaskWizardLayout>
      ),
      confirmOnClose: inEditMode
        ? {
            cancelText: 'Finish answering questions',
            confirmText: 'Close without saving',
            content: (
              <Text mb="8">
                If you leave before you finish answering all questions, it won’t save your progress.
              </Text>
            ),
            title: 'Are you sure you want to stop?',
          }
        : undefined,
    },
  ];

  return (
    <Wizard
      steps={DisclosuresSteps}
      title="Disclosures"
      onClose={() =>
        goBack({
          before: initialLocation,
          fallbackLocation: getHubSellingRoute(),
          addressUUID,
        })
      }
    />
  );
};
